<!--
 * @Author: luxiangqiang
 * @Date: 2023-02-01 15:01:55
 * @LastEditors: luxiangqiang
 * @LastEditTime: 2023-02-13 09:37:24
-->
<template>
  <div>
    <PrimaryBanner bg-color="#E5EFFF"
      bg-image="https://video.reta-inc.com/image/default/9800316D6A40415ABCE3C9E3CF37B764-6-2.png"
      :desc-list="['简洁的支付流程', '合规的薪酬支付', '全面的账单管理']">
      <template #slogan>
        <div class="title"> 我们为您完成150+国家的<strong style="color: rgba(56, 106, 255, 1);">薪酬服务</strong></div>
      </template>
    </PrimaryBanner>
    <div class="main">
      <PrimarySection v-for="(item, index) in content" v-bind="item" :rl="!!(index % 2)" :key="index" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import content from '@/assets/contents/payroll.json';
useSeoHead();
</script>
<style lang="less" scoped>
.main {
  margin-top: 120px;
  margin-bottom: 160px;

  :deep(.primary-section .pic) {
    height: 400px;
  }
}

@media screen and (min-width: 800px) {
  .main {
    min-width: 1280px;
    padding: 0 32px;
  }

  .title {
    white-space: nowrap
  }
}

@media screen and (max-width: 800px) {
  .main {
    margin-top: 24px;
    margin-bottom: 40px;
    padding: 0 20px;
    box-sizing: border-box;

    :deep(.primary-section .pic) {
      height: auto;
      aspect-ratio: 6 / 4;
    }

    :deep(.content) {
      margin-top: 20px !important;
      font-size: 16px !important;
    }
  }
}
</style>
